module.exports = __webpack_public_path__ + "static/media/pink.6c24a1e3.png";